import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css'],
   providers: [HelperService] 
})
export class SalesComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  searchTerm;
  packages;
  coupons;
  searchResult = [];
  searchPackage = [];
  searchCoupon = [];

  from;
  to;
  datas:any=[];
  data:any=[];
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;
  start_date;
  end_date;
  isDashboard;
 	name: string;
 	package: string;
 	status: string;
 	mode: string;
   coupon: string;
   user_permissions:any=[];
   user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});

 constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
    
      activatedRouter.queryParams.subscribe(params => {
    this.from = params['from'];
    this.to = params['to'];
    if(params['student'])
    	this.name = params['student'];
    else
    	this.name = '';
    if(params['package'])
	    this.package = params['package'];
	else
	    this.package = '';
	if(params['status'])
	    this.status = params['status'];
	else
	    this.status = '';
	if(params['mode'])
	    this.mode = params['mode'];
	else
	    this.mode = '';
	if(params['coupon'])
	    this.coupon = params['coupon'];
	else
	    this.coupon = '';
    if(this.from!=0){
       this.start_date  = new Date(Date.parse(this.from));
      
     this.end_date = new Date(Date.parse(this.to));
     
    }
    if(params['isDashboard'])
    	this.isDashboard = params['isDashboard'];
    else
    	this.isDashboard = '';
});
     

  }


  ngOnInit() {
    // this.http.get(this.helper.base_url+'http/checkuserLogged?token='+this.user_token)
    // .subscribe(data => {
    // // if(this.cookieService.get('auth')=="Y"){
    //   //console.log(data.status);
    //   if(data.status ==200)
    //   {
    //     this.data = JSON.parse(data['_body']);
    //     if(this.data.status != "error")
    //     {
        let user=this.cookie.get('user_id');
        this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
        
        .subscribe(data => {
          this.user_permissions = JSON.parse(data['_body']);
        //console.log(this.user_permissions);
            
        
        });
        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          order:[],
          dom: 'Bfrtip',
          buttons: [
            {
              extend: "excel",
              filename:  "SalesReport",
              exportData: { decodeEntities: true },
              exportOptions: {
                columns: [0,1,2,3,4,5,6,7,8,9,10,12,13,14,15]
            }
          },
          {
              extend: "csv",
              filename:  "SalesReport",
              exportData: {decodeEntities:true},
              exportOptions: {
                columns: [0,1,2,3,4,5,6,7,8,9,10,12,13,14,15]
            }
          }
            //  'csv','pdf','excel'
            ],
            columnDefs: [
              {
                  "targets": [ 5 ],
                  "visible": false,
                  "searchable": false
              },
              {
                  "targets": [ 6 ],
                  "visible": false,
                  "searchable": false
              },
              {
                "targets": [ 14 ],
                "visible": false,
                "searchable": false
            },
            {
              "targets": [ 15 ],
              "visible": false,
              "searchable": false
          }

          ]
        };
    
    this.http.get(this.helper.base_url+'http/get/salesReport?from='+this.from+'&to='+this.to+'&student='+this.name+'&package='+this.package+'&status='+this.status+'&mode='+this.mode+'&coupon='+this.coupon+'&isDashboard='+this.isDashboard,{ headers: this.headers })
      
      .subscribe(data => {
        this.datas = JSON.parse(data['_body']).sales;
        this.searchTerm = JSON.parse(data['_body']).student;
        this.packages = JSON.parse(data['_body']).package;
        this.coupons = JSON.parse(data['_body']).coupon;
        
          this.dtTrigger.next();
        
       
      });
  //   }else{
  //     //alert("not logged");
  //     //this.userAuth=false;
  //     //this.router.navigate(["login/"]);
  //     this.router.navigate(['login/'])
  //     .then(() => {
  //       window.location.reload();
  //     });
  //   }
  // }
  // else{
  //   //this.userAuth=false;
  //     //this.router.navigate(["login/"]);
  //     this.router.navigate(['login/'])
  //     .then(() => {
  //       window.location.reload();
  //     });
  // }
    
  // });
}

  	searchName(name)
  	{
  
	  	if(name != '')
	  	{
	    	this.http.get(this.helper.base_url+'http/get/getStudentByName?student=' + name,{ headers: this.headers }).subscribe(data => {
	        	this.searchResult = JSON.parse(data['_body']);
	      	});
	    }
  	}

  	nameChange(name)
  	{
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   		this.router.navigate(['reports/sales'], { queryParams: { from: this.from,to: this.to,student:name,package:this.package,status:this.status,mode:this.mode,coupon:this.coupon } }));
  	}

  	searchPackageFn(name)
  	{
  
	  	if(name != '')
	  	{
	    	this.http.get(this.helper.base_url+'http/get/getPackageByName?package=' + name,{ headers: this.headers }).subscribe(data => {
	        	this.searchPackage = JSON.parse(data['_body']);
	      	});
	    }
  	}

  	packageChange(name)
  	{
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   		this.router.navigate(['reports/sales'], { queryParams: { from: this.from,to: this.to,student:this.name,package:name,status:this.status,mode:this.mode,coupon:this.coupon } }));
  	}

  	searchCoupons(name)
  	{
  
	  	if(name != '')
	  	{
	    	this.http.get(this.helper.base_url+'http/get/getCouponByName?coupon=' + name,{ headers: this.headers }).subscribe(data => {
	        	this.searchCoupon = JSON.parse(data['_body']);
	      	});
	    }
  	}

  	couponChange(name)
  	{
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   		this.router.navigate(['reports/sales'], { queryParams: { from: this.from,to: this.to,student:this.name,package:this.package,status:this.status,mode:this.mode,coupon:name } }));
  	}

  	statusChange(name)
  	{
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   		this.router.navigate(['reports/sales'], { queryParams: { from: this.from,to: this.to,student:this.name,package:this.package,status:name,mode:this.mode,coupon:this.coupon } }));
  	}

  	modeChange(name)
  	{
  		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   		this.router.navigate(['reports/sales'], { queryParams: { from: this.from,to: this.to,student:this.name,package:this.package,status:this.status,mode:name,coupon:this.coupon } }));
  	}



   startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
  
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


   if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
      this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   this.router.navigate(['reports/sales'], { queryParams: { from: start_date,to: end_date,student:this.name,package:this.package,status:this.status,mode:this.mode,coupon:this.coupon } }));
     
    }
   }
   
  }

  endEvent(type: string, event: MatDatepickerInputEvent<Date>) {
 
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


    if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
        this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
        this.router.navigate(['reports/sales'], { queryParams: { from: start_date,to: end_date,student:this.name,package:this.package,status:this.status,mode:this.mode,coupon:this.coupon } }));
    }


   }
 
  }

  clearSearch()
  {
    this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
      this.router.navigate(["reports/sales"], { queryParams: { from: 0,to: 0}}));
  }

}



// WEBPACK FOOTER //
// ./src/app/sales/sales.component.ts